/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Render_Tts_TitleInputs */



/**
* | output |
* | --- |
* | "Render virtual audio (text-to-speech)" |
*
* @param {Event_Ad_Render_Tts_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_render_tts_title = /** @type {((inputs?: Event_Ad_Render_Tts_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Render_Tts_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Generer un audio virtuel (synthese vocale)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Virtuelles Audio rendern (Text-zu-Sprache)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rendering audio virtuale (testo-voce)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Воспроизведение виртуального звука (преобразование текста в речь)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Renderizar audio virtual (texto a voz)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("渲染虚拟音频（文本转语音）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("仮想オーディオ（テキスト読み上げ）をレンダリングする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्चुअल ऑडियो (टेक्स्ट-टू-स्पीच) प्रस्तुत करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Renderizar áudio virtual (conversão de texto em fala)")
	return /** @type {LocalizedString} */ ("Render virtual audio (text-to-speech)")
});